export const formatHour = hour => {
  return `${hour}:00:00`;
};



// WEBPACK FOOTER //
// ./src/utilities/common.js